export default {
	bookingList: state => state.bookingList.map(id => state.bookings[id]),
	lotteryEntryList: state => state.lotteryEntryIds.map(id => state.lotteryEntries[id]),
}